export const BRANDS = ["Goodman", "Daikin", "Bryant", "Rheem", "Trane", "Carrier", "American Standard", "Ruud", "Coldflow"];

const LOGOS = [
  { name: "Goodman", src: "/brands/goodman.svg" },
  { name: "Daikin", src: "/brands/daikin.svg" },
  { name: "Bryant", src: "/brands/bryant.svg" },
  { name: "Rheem", src: "/brands/rheem.svg" },
  { name: "Trane", src: "/brands/trane.svg" },
  { name: "Carrier", src: "/brands/carrier.svg" },
  { name: "American Standard", src: "/brands/american-standard.svg" },
  { name: "Ruud", src: "/brands/ruud.svg" },
  { name: "Coldflow", src: "/brands/coldflow.svg" },
];

export const BrandsRow = () => (
  <section data-testid="brands-row" className="bg-white border-y border-zinc-200">
    <div className="max-w-7xl mx-auto px-4 py-12">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 text-center mb-8">Brands We Carry</p>
      <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-8 sm:gap-x-12">
        {LOGOS.map((b) => (
          <img key={b.name} src={b.src} alt={`${b.name} logo`}
            data-testid={`brand-logo-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="h-8 sm:h-10 w-auto max-w-[140px] object-contain hover:scale-105 transition-transform duration-200"
            loading="lazy" />
        ))}
      </div>
      <p className="text-center text-sm text-zinc-500 mt-8">
        Leading national brands, installed and backed by licensed pros — we'll recommend the right fit for your home and budget.
      </p>
    </div>
  </section>
);
